import { OptionMeetingTypeOverride } from '@chilipiper/api-client/src/team-scheduling'
import { MeetingAttemptV2 } from '@chilipiper/api-client/src/user-availability'

export const getEmptyMeetingTypeOverride = (): OptionMeetingTypeOverride => {
  return {
    meetingInvite: {
      title: { type: 'LeaveAsIs' },
      description: { type: 'LeaveAsIs' },
    },
    reminder: {
      reminders: { type: 'LeaveAsIs' },
    },
    buffers: {
      after: {
        type: 'LeaveAsIs',
      },
      before: {
        type: 'LeaveAsIs',
      },
    },
  }
}

export const fromMeetingAttemptOverrides = (
  attempt?: MeetingAttemptV2
): OptionMeetingTypeOverride => {
  return {
    meetingInvite: {
      description: attempt?.meetingInvite.descriptionOverride
        ? {
            type: 'Change',
            value: attempt.meetingInvite.descriptionOverride,
          }
        : { type: 'LeaveAsIs' },
      title: attempt?.meetingInvite.titleOverride
        ? { type: 'Change', value: attempt.meetingInvite.titleOverride }
        : { type: 'LeaveAsIs' },
    },
    reminder: {
      reminders: {
        type: 'LeaveAsIs',
      },
    },
    buffers: {
      after: {
        type: 'LeaveAsIs',
      },
      before: {
        type: 'LeaveAsIs',
      },
    },
  }
}

export const getMeetingTypeOverride = (attempt?: MeetingAttemptV2) => {
  const meetingTypeOverride = fromMeetingAttemptOverrides(attempt)
  return {
    ...meetingTypeOverride,
    locations: attempt?.meetingInvite.possibleLocationsOverride,
    duration: attempt?.meetingInvite.meetingDurationOverride,
  }
}
